// src/utils.js
export const normalizeIngredientForSuper = (ing = {}) => {
  const name = (ing.nombre || "").trim();

  /* helper ─ formateo y conversión */
  const fmt = (rawQty = 0, assumedUnit = "") => {
    const qty  = Number(rawQty) || 0;
    const unit = assumedUnit.toLowerCase();

    /* gramos → kilos */
    if (unit === "g" || unit === "gramos") {
      if (qty >= 1000) {
        const kg = +(qty / 1000).toFixed(2);
        return { qty: kg, unit: "kilos", display: `${kg} kilos (${qty} g)` };
      }
      return { qty: +qty.toFixed(2), unit: "g", display: `${qty.toFixed(2)} g` };
    }

    /* mililitros → litros  (solo se entra aquí si NOSOTROS
       pasamos assumedUnit === "ml" para los líquidos) */
    if (unit === "ml") {
      if (qty >= 1000) {
        const l = +(qty / 1000).toFixed(2);
        return { qty: l, unit: "litros", display: `${l} litros (${qty} ml)` };
      }
      return { qty: +qty.toFixed(2), unit: "ml", display: `${qty.toFixed(2)} ml` };
    }

    /* piezas u otra unidad */
    return { qty: +qty.toFixed(2), unit, display: `${qty.toFixed(2)} ${unit}` };
  };

  /* ────────── grupos especiales (piezas / g / ml) ────────── */

  /* Huevo → piezas */
  const eggGroup = [
    "Huevo","Clara de huevo","Huevo cocido","Huevo batido o revuelto cocido",
    "Huevo deshidratado","Huevo fresco","Huevo blanco cocido","Huevo entero fresco",
    "Huevo entero cocido","Huevo frito","Huevo estrellado","Huevo revuelto","Yema de huevo",
  ];
  if (eggGroup.includes(name)) {
    const piezas = (["pieza","piezas"].includes((ing.unit||ing.unidad||"").toLowerCase().trim()))
      ? Math.ceil(+ing.cantidad || 0)
      : Math.ceil(+ing.equivalente || +ing.equivalentes || +ing.eq || +ing.cantidad || 0);
    return { name: "Huevo", ...fmt(piezas, "pza") };
  }

  /* Tortilla → gramos */
  const tortillaGroup = ["Tortilla de maíz blanco","Tortilla de maíz","Tortilla"];
  if (tortillaGroup.includes(name)) {
    const q = Math.ceil(ing.pesoBruto ?? ing.cantidad ?? 0);
    return { name: "Tortilla de maíz", ...fmt(q, "g") };
  }

  /* Pechuga de pollo → gramos */
  const pechugaPollo = [
    "Pechuga de pollo sin piel","Pechuga de pollo deshuesada sin piel cruda",
    "Pechuga de pollo sin piel cocida","Pechuga de pollo sin piel asada",
    "Pechuga de pollo sin piel cruda","Pechuga de pollo sin piel en brocheta cruda",
    "Pechuga de pollo sin piel en fajitas cruda","Pechuga de pollo ahumada",
    "Pechuga de pollo sin piel horneada rebanada","Pechuga de pollo sin piel molida cruda",
    "Pechuga de pollo sin piel aplanada","Pechuga de pollo sin piel a la plancha",
    "Fajitas de pollo sin piel cruda","Pastel de pollo",
  ];
  if (pechugaPollo.includes(name)) {
    const q = Math.ceil(ing.pesoBruto ?? ing.cantidad ?? 0);
    return { name: "Pechuga de pollo", ...fmt(q, "g") };
  }

  /* Avena → gramos */
  const avenaGroup = ["Avena cocida","Avena en hojuelas","Hojuelas de avena"];
  if (avenaGroup.includes(name)) {
    const q = Math.ceil(ing.pesoBruto ?? ing.cantidad ?? 0);
    return { name: "Avena", ...fmt(q, "g") };
  }

  /* Líquidos → mililitros (asumidos) */
  const liquidsGroup = [
    "Agua","Agua de coco","Jugo de limón","Jugo de mamey",
    "Jugo de mandarina natural","Jugo de mango","Jugo de naranja natural",
    "Jugo de papaya","Jugo de toronja natural", "Leche descremada", "Leche","Leche caliente",
    "Leche clavel","Leche cruda","Naranjada concentrada","Jocoque", "Leche evaporada descremada",
    "Jocoque ligero","Jocoque seco","Salsa de arándanos en gelatina enlatada",
    "Papilla de chabacano con tapioca","Papilla de durazno", "Leche Lala Light", 
    "Papilla de guayaba y papaya con tapioca","Papilla de mango con tapioca",
    "Papilla de manzana","Papilla de manzana y chabacano","Papilla de pera",
    "Papilla de pera y piña","Papilla de plátano y piña con tapioca", "Leche light Extra",
    "Pulpa de fresa","Pulpa de guanábana","Pulpa de mamey","Pulpa de tamarindo",
    "Pulpa de zapote negro","Puré de ciruela pasa","Puré de guayaba",
    "Puré de guayaba Gerber 2A etapa","Puré de manzana","Puré de manzana sin azúcar",
    "Puré de plátano", "Café americano", "Chocolate con leche", "Chocolate con leche y almendras sin azúcar",
    "Chocolate con leche y almendras sin azúcar", "Leche evaporada semidescremada", "Leche fácil digestión",
    "Leche Lactium MX", "Leche Lala Extracalcio Deslactosada", "Leche Lala Extracalcio Semidescremada",
    "Leche Lala Semidescremada", "Leche Lala Vive Deslactosada semidescremada", "Leche semidescremada",
    "Leche clavel", "Leche de burra", "Leche de cabra", "Leche de vaca", "Leche cruda", "Leche entera baja en sodio", 
    "Leche entera evaporada", "Leche entera evaporada", "Leche entera ultra pasteurizada", "Leche evaporada", "Leche fría",
    "Leche hervida", "Leche humana", "Leche Lala Entera", "Leche materna", "Leche omega verde", "Leche pasteurizada", 
    "Leche con chocolate", "Leche preparada", "Leche con vainilla", "Leche de soya saborizada", "Leche de soya", "Leche descremada con chocolate",
    "Leche Lala saborizada",
  ];
  if (liquidsGroup.includes(name)) {
    const q = Math.ceil(ing.pesoBruto ?? ing.cantidad ?? 0); // se interpreta como mL
    return { name, ...fmt(q, "ml") };
  }

  /* Resto → gramos */
  const q = Math.ceil(ing.pesoBruto ?? ing.cantidad ?? 0);
  return { name, ...fmt(q, "g") };
};

  
/* ----- mapa fijo idCategoria → grupoSimplificado ----- */
const CATEGORIA_GRUPO_MAP = {
  /* Aceites y grasas */
  "58d195b4e2bf6a5b5588ff64": "Aceites y grasas",
  "58d195c4e2bf6a5b5588ff65": "Aceites y grasas",

  /* Alimentos de origen animal */
  "58d195cfe2bf6a5b5588ff66": "Alimentos de origen animal",
  "58d195d9e2bf6a5b5588ff67": "Alimentos de origen animal",
  "58d195e4e2bf6a5b5588ff68": "Alimentos de origen animal",
  "58d195efe2bf6a5b5588ff69": "Alimentos de origen animal",

  /* Azúcares */
  "58d19601e2bf6a5b5588ff6b": "Azucares",
  "58d1960ae2bf6a5b5588ff6c": "Azucares",

  /* Lácteos */
  "58d1963de2bf6a5b5588ff71": "Lacteos",
  "58d19647e2bf6a5b5588ff72": "Lacteos",
  "58d1964fe2bf6a5b5588ff73": "Lacteos",
  "58d19656e2bf6a5b5588ff74": "Lacteos",

  /* Frutas y verduras */
  "58d1962be2bf6a5b5588ff70": "Frutas y verduras",
  "58d19664e2bf6a5b5588ff76": "Frutas y verduras",

  /* Cereales */
  "58d1961ce2bf6a5b5588ff6e": "Cereales",
  "58d19624e2bf6a5b5588ff6f": "Cereales",

  /* Leguminosas */
  "58d1965de2bf6a5b5588ff75": "Leguminosas",
};

/* ----- mapa completo idCategoria → nombreReal ----- */
export const CATEGORIA_NOMBRE_MAP = {
  "58d195b4e2bf6a5b5588ff64": "Aceites y grasas sin proteína",
  "58d195c4e2bf6a5b5588ff65": "Aceites y grasas con proteína",
  "58d195cfe2bf6a5b5588ff66": "Alimentos de origen animal moderado aporte de grasa",
  "58d195d9e2bf6a5b5588ff67": "Alimentos de origen animal alto aporte de grasa",
  "58d195e4e2bf6a5b5588ff68": "Alimentos de origen animal bajo aporte de grasa",
  "58d195efe2bf6a5b5588ff69": "Alimentos de origen animal muy bajo aporte de grasa",
  "58d195f9e2bf6a5b5588ff6a": "Alimentos libres en energía",
  "58d19601e2bf6a5b5588ff6b": "Azúcares con grasa",
  "58d1960ae2bf6a5b5588ff6c": "Azúcares sin grasa",
  "58d19613e2bf6a5b5588ff6d": "Bebidas alcohólicas",
  "58d1961ce2bf6a5b5588ff6e": "Cereales con grasa",
  "58d19624e2bf6a5b5588ff6f": "Cereales sin grasa",
  "58d1962be2bf6a5b5588ff70": "Frutas",
  "58d1963de2bf6a5b5588ff71": "Leche con azúcar",
  "58d19647e2bf6a5b5588ff72": "Leche descremada",
  "58d1964fe2bf6a5b5588ff73": "Leche entera",
  "58d19656e2bf6a5b5588ff74": "Leche semidescremada",
  "58d1965de2bf6a5b5588ff75": "Leguminosas",
  "58d19664e2bf6a5b5588ff76": "Verduras",
};

/**
 * Devuelve el nombre de agrupación o, en su defecto, la categoría real.
 */
export const getGrupoByCategoriaId = (id, fallbackNombre = "") =>
  CATEGORIA_GRUPO_MAP[id] ||
  CATEGORIA_NOMBRE_MAP[id] ||
  fallbackNombre ||
  "Sin categoría";